<template>
  <div class="lose">
    <img src="../../assets/images/notfind.png" alt="" />
    <p>哎呀，找不到页面了</p>
    <p class="mar-top">不要伤心，可能地址错了呢</p>
    <!-- <van-button type="info" plain class="load-btn">重新加载</van-button> -->
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="less">
.lose {
  text-align: center;
  padding-top: 280px;
  img {
    width: 200px;
  }
  p {
    font-size: 26px;
    margin-top: 30px;
  }
  .mar-top {
    margin-top: 20px;
  }
  .load-btn {
    width: 220px;
    height: 80px;
    border-radius: 49px;
    margin-top: 50px;
  }
}
</style>
